// extracted by mini-css-extract-plugin
export default {"inativo":"MenuLateralCategorias_inativo__1WrCI"};